import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AdminLogsState, adminLogsInitialState } from './logs.state';
import { GetLogsFilesResponse } from 'App/api/endpoints/logs/responses';
import { StatusType } from 'App/types/requestStatus';

const { FAILED, LOADING, SUCCESS } = StatusType;

export const adminLogsSlice = createSlice({
	name: 'admin-logs',
	initialState: adminLogsInitialState,
	reducers: {
		getLogsFilesStart: (state: AdminLogsState) => {
			state.status.getLogsFiles = LOADING;
			state.logs = adminLogsInitialState.logs;
		},
		getLogsFilesSuccess(state: AdminLogsState, action: PayloadAction<GetLogsFilesResponse>) {
			state.status.getLogsFiles = SUCCESS;
			state.logs = action.payload.logs;
		},
		getLogsFilesFailure(state: AdminLogsState) {
			state.status.getLogsFiles = FAILED;
		},

		getLogsFileContentStart: (state: AdminLogsState) => {
			state.status.getLogsFileContent = LOADING;
			state.logContent = adminLogsInitialState.logContent;
		},
		getLogsFileContentSuccess(state: AdminLogsState, action: PayloadAction<string[]>) {
			state.status.getLogsFileContent = SUCCESS;
			state.logContent = action.payload;
		},
		getLogsFileContentFailure(state: AdminLogsState) {
			state.status.getLogsFileContent = FAILED;
		},

		downloadLogsFileStart: (state: AdminLogsState) => {
			state.status.downloadLogsFile = LOADING;
		},
		downloadLogsFileSuccess(state: AdminLogsState) {
			state.status.downloadLogsFile = SUCCESS;
		},
		downloadLogsFileFailure(state: AdminLogsState) {
			state.status.downloadLogsFile = FAILED;
		},

		downloadAllLogsFilesStart: (state: AdminLogsState) => {
			state.status.downloadAllLogsFiles = LOADING;
		},
		downloadAllLogsFilesSuccess(state: AdminLogsState) {
			state.status.downloadAllLogsFiles = SUCCESS;
		},
		downloadAllLogsFilesFailure(state: AdminLogsState) {
			state.status.downloadAllLogsFiles = FAILED;
		},

		cleanUpLogStatusStart: (state: AdminLogsState) => {
			state.status = adminLogsInitialState.status;
		},
	},
});

export default adminLogsSlice;

export const {
	getLogsFilesStart,
	getLogsFilesSuccess,
	getLogsFilesFailure,

	getLogsFileContentStart,
	getLogsFileContentSuccess,
	getLogsFileContentFailure,

	downloadLogsFileStart,
	downloadLogsFileSuccess,
	downloadLogsFileFailure,

	downloadAllLogsFilesStart,
	downloadAllLogsFilesSuccess,
	downloadAllLogsFilesFailure,

	cleanUpLogStatusStart,
} = adminLogsSlice.actions;
